// Classes.
import {BaseLocator} from './../locators/base.locator';
import {StringLocatorComponent} from './../locators/string.locator-component';
import {DisciplineLocatorComponent} from './../locators/discipline.locator-component';
import {YearLocatorComponent} from './../locators/year.locator-component';


export class WCupRankingCategoryListLocator extends BaseLocator {

  public name: StringLocatorComponent;
  public discipline: DisciplineLocatorComponent;
  public year: YearLocatorComponent;

  constructor() {
    super("wCupRankingCategoryList");
    this.addComponentByType('discipline');
    this.addComponentByType('year');
  }
}


